// extracted by mini-css-extract-plugin
module.exports = {"video":"Slider_video__23CzS","carouselItem":"Slider_carouselItem__1MZ80"};